import {
  Table as MantineTable,
  type TableProps as MantineTableProps,
} from '@mantine/core';
import type { CoreComponentProps } from '../../types';
import { useShouldRender } from '../../../hooks/useShouldRender';

export type TableProps = CoreComponentProps<MantineTableProps, 'div'>;

function TableRoot({ testId, view = 'all', ...rest }: TableProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineTable data-testid={testId} {...rest} />;
}

export const Table = Object.assign(TableRoot, {
  Thead: MantineTable.Thead,
  Tbody: MantineTable.Tbody,
  Tr: MantineTable.Tr,
  Th: MantineTable.Th,
  Td: MantineTable.Td,
  Caption: MantineTable.Caption,
  ScrollContainer: MantineTable.ScrollContainer,
});
